import { IApiAction, IApiResponse } from '../types';

type ActionKey = 'EDDY-SERVICE';

export const ACTION_KEY: ActionKey = 'EDDY-SERVICE';

export enum ServiceMethod {
  CREATE_EDDY_PROJECT = 'CREATE_EDDY_PROJECT',
  GET_EDDY_PROJECT = 'GET_EDDY_PROJECT',
}

type ApiAction<M extends ServiceMethod, A> = IApiAction<ActionKey, M, A>;

export type EddyProjectMediaType = 'audio' | 'video';

export type EddyProjectAssociatedMedia = {
  makeVideoWidgetId: string;
  mediaType: EddyProjectMediaType;
};

export type EddyProjectStatus =
  | 'queued'
  | 'processing'
  | 'completed'
  | 'error'
  | 'notFound';

export type EddyProjectThumbnail = {
  imageUrl: string;
  width: number;
  height: number;
};

export type EddyProjectCreateMethod = 'eddyDirectUpload';

export type EddyProjectProgress = {
  percentMilli: number;
};

export type EddyProjectTranscript = {
  id: number;
  status: EddyProjectStatus;
};

export type EddyEdgeAssetType = 'intro' | 'outro';

export type EddyProjectEdgetAsset = {
  id: number;
  edgeAssetType: EddyEdgeAssetType;
  thumbnail: EddyProjectThumbnail;
  durationMillis: number;
  status: EddyProjectStatus;
};

export type EddyProjectEdgetAssets = {
  intro: EddyProjectEdgetAsset;
  outro: EddyProjectEdgetAsset;
};

export type EddyProject = {
  projectId: number;
  projectCuid: string;
  name: string;
  creatorUserId: number;
  traceId: string;
  createdAt: number;
  updatedAt: number;
  status: EddyProjectStatus;
  url: string;
  thumbnail: EddyProjectThumbnail;
  mediaDurationMillis: number;
  createMethod: EddyProjectCreateMethod;
  isAutoChaptersEnabled: boolean;
  isNameSuggestionEnabled: boolean;
  isFillerWordsRemovalEnabled: boolean;
  isNameSuggestionApplied: boolean;
  isFillerWordsRemoved: boolean;
  hasSubmittedRelatedPodcast: boolean;
  progress: EddyProjectProgress;
  associatedMedias: EddyProjectAssociatedMedia[];
  projectTranscript: EddyProjectTranscript;
  edgeAssets: EddyProjectEdgetAssets;
};

export type CreateEddyProjectActionArgs = [
  string /* name */,
  EddyProjectAssociatedMedia /* associated media */,
];

export type CreateEddyProjectResult = {
  projectId: number;
  projectCuid: string;
  url: string;
};

export type CreateEddyProjectAction = ApiAction<
  ServiceMethod.CREATE_EDDY_PROJECT,
  CreateEddyProjectActionArgs
>;

export type GetEddyProjectActionArgs = [string /* projectCuid */];

export type GetEddyProjectResult = EddyProject;

export type GetEddyProjectAction = ApiAction<
  ServiceMethod.GET_EDDY_PROJECT,
  GetEddyProjectActionArgs
>;

export interface EddyServiceDispatch {
  (action: CreateEddyProjectAction): Promise<
    IApiResponse<CreateEddyProjectResult>
  >;
  (action: GetEddyProjectAction): Promise<IApiResponse<GetEddyProjectResult>>;
}
